import AppErrorWrapper from 'pages/AppErrorWrapper/AppErrorWrapper';

export default AppErrorWrapper;
